import React from 'react';
import ReactECharts from 'echarts-for-react';

const EChartBarComponent = ({ label, value1, value2, chartData, chartHeight, chartHeading, color1, color2 }) => {
    const isEmpty = !chartData || chartData.length === 0;

    // Map chartData dynamically using props
    const categories = chartData ? chartData.map(item => item[label]) : [];
    const series1Data = chartData ? chartData.map(item => item[value1]) : [];
    const series2Data = chartData ? chartData.map(item => item[value2]) : [];

    const option = {
        title: {
            text: chartHeading || '',
            left: 'center',
            textStyle: {
                fontSize: 14,
                fontWeight: 'bold',
                color: '#333'
            }
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        legend: {
            bottom: 0,
            textStyle: { fontSize: 11 }
        },
        grid: {
            top: '15%',
            left: '3%',
            right: '8%',
            bottom: '12%',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: {
                lineStyle: { type: 'dashed', color: '#eee' }
            }
        },
        yAxis: {
            type: 'category',
            data: categories,
            axisTick: { show: false },
            axisLine: { lineStyle: { color: '#ccc' } },
            axisLabel: {
                fontSize: 10,
                fontWeight: '600',
                color: '#333'
            }
        },
        series: [
            {
                name: value1,
                type: 'bar',
                data: series1Data,
                itemStyle: {
                    color: color1 || '#2563EB',
                    borderRadius: [0, 4, 4, 0]
                },
                barGap: '15%',
                label: {
                    show: true,
                    position: 'right',
                    fontSize: 10,
                    formatter: '{c}'
                }
            },
            {
                name: value2,
                type: 'bar',
                data: series2Data,
                itemStyle: {
                    color: color2 || '#F97316',
                    borderRadius: [0, 4, 4, 0]
                },
                label: {
                    show: true,
                    position: 'right',
                    fontSize: 10,
                    formatter: '{c}'
                }
            }
        ]
    };

    return (
        <div style={{ width: '100%' }}>
            {isEmpty ? (
                <div style={{
                    height: chartHeight ? chartHeight : '500px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: '#888'
                }}>
                    No Data Available
                </div>
            ) : (
                <ReactECharts
                    option={option}
                    style={{ height: chartHeight ? chartHeight : '500px', width: '100%' }}
                />
            )}
        </div>
    );
};

export default EChartBarComponent;